import * as React from "react";

import { Link, useNavigate } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";

import Button from "../../Components/Button";
import Paper from "../../Components/Paper";

import axiosInstance from "../../Api/Axios";
import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

import "./AddReleaseRequests.scss";
import GetClosedContracts from "../../ListSelect/GetClosedContracts";

const initialFormState = {
  contract_number: "",
};

const AddReleaseRequests = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (e, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/release-requests`, {
        contract_number: valRegister.contract_number,
      })
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/release-requests");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  return (
    <>
      <div className="back-home">
        <Link to="/release-requests" className="link-back">
          <RiArrowLeftLine />
        </Link>
      </div>
      <h1>Demandes de mainlevée</h1>
      <p>Veuillez remplir les champs ci dessous</p>
      <Paper>
        <form className="register-form" onSubmit={handleSubmit} noValidate>
          <GetClosedContracts
            label="Numéro de contrat"
            id="contract_number"
            value={valRegister.contract_number || ""}
            onChange={(e) => handleChangeField(e, "contract_number")}
            hasError={formErrorMessages.contract_number}
            errorMessage={
              <div className="text-danger">
                {formErrorMessages.contract_number}
              </div>
            }
          ></GetClosedContracts>

          <div className="wrap_actions_form">
            <Button type="submit" size="lg">
              Envoyer
            </Button>
          </div>
        </form>
      </Paper>
    </>
  );
};

export default AddReleaseRequests;
